import { subscriptionState } from './subscription.state';
import { subscriptionActions } from './subscription.actions';
import { subscriptionGetters } from './subscription.getters';
import { subscriptionMutations } from './subscription.mutations';

export default {
  state: subscriptionState,
  actions: subscriptionActions,
  getters: subscriptionGetters,
  mutations: subscriptionMutations,
};
